const fmtValue = (v) => (v == null || v === "" ? "—" : typeof v === "object" ? JSON.stringify(v) : String(v));

function elapsed(e, t0) {
  if (e.elapsed_s != null) return `+${Number(e.elapsed_s).toFixed(1)}s`;
  if (!e.timestamp || !t0) return "—";
  return `+${((new Date(e.timestamp) - t0) / 1000).toFixed(1)}s`;
}

const clock = (ts) => {
  if (!ts) return "";
  try { return new Date(ts).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit" }); } catch { return ""; }
};

const Flag = ({ on, label, tone }) => on ? <span className={`px-1.5 py-0.5 border text-[10px] font-mono-disp ${tone}`}>{label}</span> : null;

export function BehaviourLog({ cid, events = [] }) {
  const t0 = events[0]?.timestamp ? new Date(events[0].timestamp) : null;
  return (
    <div className="mt-5" data-testid={`behaviour-log-${cid}`}>
      <div className="label-mono mb-2">Behaviour event log · {events.length} events</div>
      {events.length === 0 ? (
        <p className="text-xs text-[var(--iddl-muted)] border border-[var(--iddl-rule)] p-3" data-testid={`behaviour-log-empty-${cid}`}>
          No behaviour events were recorded for this concept.
        </p>
      ) : (
        <div className="border border-[var(--iddl-rule)] max-h-96 overflow-auto">
          <table className="w-full text-xs">
            <thead className="sticky top-0 bg-[var(--iddl-surface)] text-left">
              <tr className="label-mono">
                {["#", "Time", "Event", "Value", "Screen", "Flags"].map((h) => (
                  <th key={h} className="px-3 py-2 font-normal border-b border-[var(--iddl-rule)]">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {events.map((e, i) => (
                <tr key={i} className="border-b border-[var(--iddl-rule)] last:border-0 align-top" data-testid={`behaviour-log-row-${cid}-${i}`}>
                  <td className="px-3 py-1.5 text-[var(--iddl-muted)]">{e.order ?? i + 1}</td>
                  <td className="px-3 py-1.5 whitespace-nowrap">
                    {elapsed(e, t0)} <span className="text-[var(--iddl-muted)]">{clock(e.timestamp)}</span>
                  </td>
                  <td className="px-3 py-1.5 font-mono-disp font-semibold break-all">{e.event}</td>
                  <td className="px-3 py-1.5 font-mono-disp break-all max-w-[360px]">{fmtValue(e.value)}</td>
                  <td className="px-3 py-1.5 text-[var(--iddl-muted)] break-all">{e.screen || "—"}</td>
                  <td className="px-3 py-1.5">
                    <div className="flex flex-wrap gap-1">
                      <Flag on={e.required} label="required" tone="border-emerald-300 bg-emerald-50 text-emerald-800" />
                      <Flag on={e.critical} label="critical" tone="border-amber-300 bg-amber-50 text-amber-800" />
                      <Flag on={e.auto_fail} label="auto-fail" tone="border-rose-300 bg-rose-50 text-rose-700" />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
